import { render, staticRenderFns } from "./RequisitionAttachmentListItem.vue?vue&type=template&id=18e8c3a7&"
import script from "./RequisitionAttachmentListItem.vue?vue&type=script&lang=ts&"
export * from "./RequisitionAttachmentListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports